import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    islogin:null,
    user:null,
  },
  mutations: {
    islogin:(state,value)=>{
      console.log(15151,value);
      state.islogin=value
    },
    user:(state,value)=>{
      state.user=value
    },
  },
  actions: {
  },
  modules: {
  }
})
